<template>
  <div class="col-12 px-0">
    <load v-if="loading" mode="table" />
    <div v-else class="col-md-12 mb-3">
      <table
        class="table table-bordered bg-white table-sm"
        v-for="historico in atendimento.historico_remanejamento"
        :key="historico.id"
      >
        <tr>
          <td class="bg-gray" colspan="2">
            O <b>Atendimento</b> foi remanejado de
            <b v-if="historico.tecnico_origem_id">{{
              historico.tecnico_origem_id.name
            }}</b>
            para
            <b v-if="historico.tecnico_destino_id">{{
              historico.tecnico_destino_id.name
            }}</b>
          </td>
        </tr>
        <tr>
          <td>
            Data da ação:
            <b>{{ historico.created_at | formatDateHora }}</b>
          </td>
        </tr>
        <tr>
          <td colspan="2" v-if="historico.motivo">
            Motivo: <b>{{ historico.motivo }}</b>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["atendimento"],
  data() {
    return {
      loading: false,
      historicos: {},
    };
  },
  mounted() {},
  methods: {},
};
</script>
